import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const CheckmarkIcon = (props?: SvgProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="#19191B"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props?.title}</title>
      <path
        d="M13.3334 4L6.00002 11.3333L2.66669 8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
